import { createClient } from '@codecures/live-stream'

const param = (name: string) => new URLSearchParams(location.search).get(name)

/**
 * The app's one SDK client. Same origin: in dev, Vite proxies /api and
 * /socket.io to the backend, so the secure page never makes an insecure
 * request. Two switches ride on the address bar: `?transport=mesh` (the
 * A/B and the rollback) and `?ice=relay` (every packet through TURN).
 */
export const client = createClient({
  serverLabel: __BACKEND_TARGET__,
  emojiBase: __EMOJI_BASE__,
  media: { transport: () => param('transport'), relayOnly: param('ice') === 'relay' },
})
